import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { withStyles } from '@mui/styles';
import React, { Component } from "react";
import * as Util from "../infra/Util";

class SelectAmountDonut extends Component {
    constructor(props) {
        super(props);
        this.state = {
            num_registro: 10
        };

    }
    handleChange = (name, mask, limit, font, callback) => event => {
        this.setState({
            [name]: Util.maskFormate(event.target.value, mask, limit, font)
        }, () => {
            if (callback) return callback();
        })
    }
    componentDidMount() {
        if (this.props.onRef) {
            this.props.onRef(this)
        }
    }
    clear() {

        this.setState({ num_registro: 10 })
    }


    getQtd() {

        return this.state.num_registro;
    }

    render() {
        const { classes, subtitle, title, description, footer, avatar } = this.props;
        return (
            <FormControl style={{ width: 200, marginTop: 15 }}>
                <InputLabel id="demo-mutiple-name-label">Nº de registros</InputLabel>
                <Select
                    // style={{ width: "100%" }}
                    className={classes.select}
                    value={this.state.num_registro}
                    onChange={this.handleChange("num_registro", null, null, null, () => {
                        this.props.change(this.state.num_registro)
                    })}
                >
                    <MenuItem key={10} value={10} >
                        {"10"}
                    </MenuItem>
                    <MenuItem key={20} value={20} >
                        {"20"}
                    </MenuItem>
                    <MenuItem key={30} value={30} >
                        {"30"}
                    </MenuItem>
                    <MenuItem key={40} value={40} >
                        {"40"}
                    </MenuItem>
                    <MenuItem key={50} value={50} >
                        {"50"}
                    </MenuItem>
                    <MenuItem key={60} value={60} >
                        {"60"}
                    </MenuItem>
                    <MenuItem key={70} value={70} >
                        {"70"}
                    </MenuItem>

                    <MenuItem key={80} value={80} >
                        {"80"}
                    </MenuItem>

                    <MenuItem key={90} value={90} >
                        {"90"}
                    </MenuItem>

                    <MenuItem key={100} value={100} >
                        {"100"}
                    </MenuItem>
                    <MenuItem key={150} value={150} >
                        {"150"}
                    </MenuItem>


                </Select>
            </FormControl>
        );
    }
}


const styl = theme => ({
    icon: {
        color: "rgba(238,238,238,1)"
    },
    chip: {
        margin: theme.spacing.unit
    },
    button: {
        marginRight: 10,
        marginBottom: 10
    },
    buttonAdd: {
        right: 0,
        position: "absolute"
    }
});
export default withStyles(styl)(SelectAmountDonut);
